export default __webpack_public_path__ + "static/media/users.f4b50f69.svg";